import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import { Map, List } from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Map({}).set('Get', new List([])).set('Contracts', new List([]))

/* Types */
export const GET_CONTRACTS = 'GET_CONTRACTS'
export const GET_GRANTEE_CONTRACTS = 'GET_GRANTEE_CONTRACTS'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case GET_CONTRACTS:
			return state.set('Get', new List(action.Obj))
		case GET_GRANTEE_CONTRACTS:
			return state.set('Contracts', new List(action.Obj))
		default:
			return state;
	}
};

/* Action Creators */

export const getGranteeContracts = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getGranteeContracts',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			let { data } = response
			data = data.map((c) => {
				const { tipoContrato } = c
				return {
					tmp: 'tmp',
					id: tipoContrato.id,
					tipoContrato: tipoContrato.tipoContrato,
					documento: { idDocumento: null },
					fase: { id: "contrato", uniqueId: Utils.getUUID() },
					idContrato: c.id,
					nombre: "",
					revisado: false
				}
			})
			dispatch({ type: GET_GRANTEE_CONTRACTS, Obj: data })
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const getContracts = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getContracts',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false));

			let contratos = response.data.contratos.map((c) => {

				return {
					id: c.idDonatariaContrato,
					idTipocontrato: c.tipoContrato.idContrato,
					tipoContrato: c.tipoContrato.tipoContrato,
					documento: { idDocumento: c.documentoDropbox && c.documentoDropbox.dropboxId ? c.documentoDropbox.dropboxId : null },
					fase: { id: "contrato" },
					contrato: c.tipoContrato.idContrato,
					nombre: c.documentoDropbox && c.documentoDropbox.nombre ? decodeURI(c.documentoDropbox.nombre) : null,
					revisado: c.revisado,
					idDocumento: c.documentoDropbox && c.documentoDropbox.documentoId ? c.documentoDropbox.documentoId : null
				}
			})

			dispatch({type: GET_CONTRACTS, Obj: contratos})
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const getContract = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/downloadContract',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid}),
			responseType: 'arraybuffer'
		}).request().then(response => {
			
			dispatch(isLoading(false))

			const blob = new Blob([response.data], { type: 'application/pdf' })
			const fileName = `contratoDescarga-${Utils.getToday()}.pdf`
			const objectUrl = URL.createObjectURL(blob)
			const a = document.createElement('a')

			a.href = objectUrl
			a.download = fileName
			document.body.appendChild(a)
			a.click()

			document.body.removeChild(a)
			URL.revokeObjectURL(objectUrl)

		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const saveContracts = (form) => {

	form.autor = sessionStorage.uid
	form.contratos = form.contratos.map((c/* , index */) => {
		return {
			revisado: c.revisado || false,
			tipoContrato: {
				idContrato: c.id
			}
		}
	})

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/saveContracts',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const updateContractsInfo = (form) => {

	let temp = {
		autor: sessionStorage.uid,
		contratos: form.contratos,
		idCorrida: form.idCorrida,
		idDonataria: form.idDonataria
	}

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/updateContractsInfo',
			method: "POST",
			data: {...temp},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const clearContracts = () => {
	return (dispatch) => {
		dispatch({ type: GET_CONTRACTS, Obj: [] })
	}
}



// WEBPACK FOOTER //
// ./src/modules/MissingInfo/Contracts/index.js